import React from 'react';
import { CarouselClient } from '~/components';

const ClientCarouselTemplate = ({ items, isEditMode }) => {
  return <CarouselClient items={items} isEditMode={isEditMode} />;
};

export default ClientCarouselTemplate;
